import axios from 'axios'
import qs from 'qs'

export default {
  methods: {
    $get (url, params = {}) {
      const { baseURL } = this.$route.meta.axiosConfig
      return axios({ url, params, baseURL })
    },

    $post (url, data) {
      const { baseURL, withCredentials = false, postContentType = 'JSON' } = this.$route.meta.axiosConfig
      if(postContentType === 'JSON'){
        return axios({ url, data, method: 'post', baseURL, withCredentials })
      } else {
        return axios({
          url,
          data: qs.stringify(data),
          baseURL,
          withCredentials,
          method: 'post',
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          }
        })
      }
    }
  }
}
